import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider, ColorSchemeProvider, Global } from "@mantine/core";
import App from "./App";
import "./index.css";
import {
  THEME_PRESETS,
  ThemeSettingsContext,
  loadColorScheme,
  saveColorScheme,
  loadThemePreset,
  saveThemePreset,
  loadCustomHex,
  saveCustomHex,
  getActivePalette,
} from "./Utilities/themeSettings";

// Benign browser quirk (fires from Mantine's internal ResizeObserver usage) that
// CRA's dev error overlay otherwise treats as a crash — safe to ignore.
window.addEventListener("error", (e) => {
  if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
    e.stopImmediatePropagation();
  }
});

// S59: dark mode + theme presets — selection localStorage mein, refresh pe wapas wahi.
// Poora panel `cyan` palette use karta hai, isliye active preset ke colors cyan mein jaate hain
// (dekho Utilities/themeSettings.js ka note) — primaryColor hamesha 'cyan' hi rehta hai.
function Root() {
  const [colorScheme, setColorScheme] = useState(loadColorScheme());
  const [preset, setPresetState] = useState(loadThemePreset());
  const [customHex, setCustomHex] = useState(loadCustomHex());

  const toggleColorScheme = (value) => {
    const next = value || (colorScheme === "dark" ? "light" : "dark");
    setColorScheme(next);
    saveColorScheme(next);
  };

  const setPreset = (p) => {
    if (!THEME_PRESETS[p]) return;
    setPresetState(p);
    saveThemePreset(p);
  };

  // "Multi color" (user ka ask): koi bhi custom hex — usse poora 10-shade palette generate hota hai
  const setCustomColor = (hex) => {
    setCustomHex(hex);
    setPresetState("custom");
    saveCustomHex(hex);
    saveThemePreset("custom");
  };

  return (
    <ThemeSettingsContext.Provider
      value={{ colorScheme, toggleColorScheme, preset, setPreset, customHex, setCustomColor }}
    >
      <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
        <MantineProvider
          withGlobalStyles
          withNormalizeCSS
          theme={{
            colorScheme,
            primaryColor: "cyan",
            colors: {
              cyan: getActivePalette(preset, customHex),
            },
          }}
        >
          {/* Global body background — light/dark ke hisaab se */}
          <Global
            styles={(theme) => ({
              body: {
                backgroundColor:
                  theme.colorScheme === "dark" ? theme.colors.dark[8] : "#ffffff",
              },
            })}
          />
          <App />
        </MantineProvider>
      </ColorSchemeProvider>
    </ThemeSettingsContext.Provider>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<Root />);
